import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}
export function CountdownTimer({
  className = '',
  size = 'md'
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const sizes = {
    sm: {
      block: 'w-10 h-10 text-sm',
      label: 'text-[10px]'
    },
    md: {
      block: 'w-14 h-14 text-xl',
      label: 'text-xs'
    },
    lg: {
      block: 'w-16 h-16 md:w-20 md:h-20 text-2xl md:text-4xl',
      label: 'text-xs md:text-sm'
    }
  };
  const currentSize = sizes[size];
  return <div className={`flex items-center justify-center gap-2 md:gap-4 ${className}`} data-id="element-44">
      <div className="flex flex-col items-center" data-id="element-45">
        <div className={`bg-white border border-[#E8D5C4] rounded-lg flex items-center justify-center font-bold text-[#D4850A] shadow-md ${currentSize.block}`} data-id="element-46">
          {hours}
        </div>
        <span className={`text-[#9B8578] mt-1 uppercase tracking-wider ${currentSize.label}`} data-id="element-47">
          Horas
        </span>
      </div>
      <div className={`text-[#D4850A] font-bold pb-5 ${size === 'lg' ? 'text-2xl md:text-4xl' : 'text-xl'}`} data-id="element-48">
        :
      </div>
      <div className="flex flex-col items-center" data-id="element-49">
        <div className={`bg-white border border-[#E8D5C4] rounded-lg flex items-center justify-center font-bold text-[#D4850A] shadow-md ${currentSize.block}`} data-id="element-50">
          {minutes}
        </div>
        <span className={`text-[#9B8578] mt-1 uppercase tracking-wider ${currentSize.label}`} data-id="element-51">
          Min
        </span>
      </div>
      <div className={`text-[#D4850A] font-bold pb-5 ${size === 'lg' ? 'text-2xl md:text-4xl' : 'text-xl'}`} data-id="element-52">
        :
      </div>
      <div className="flex flex-col items-center" data-id="element-53">
        <div className={`bg-white border border-[#E8D5C4] rounded-lg flex items-center justify-center font-bold text-[#D4850A] shadow-md ${currentSize.block}`} data-id="element-54">
          {seconds}
        </div>
        <span className={`text-[#9B8578] mt-1 uppercase tracking-wider ${currentSize.label}`} data-id="element-55">
          Seg
        </span>
      </div>
    </div>;
}